import { BuilderReactivationBanner } from 'ReactivationBanner';
import { ReactivationOfferModal } from 'Modals';

window.BuilderReactivationBanner = BuilderReactivationBanner;
window.ReactivationOfferModal = ReactivationOfferModal;

require('ui-tools');
require('track-usage');
window.OfferManager = require("offer-manager");
window.SessionManager = require("session-manager");
window.exportChart = function(asPng, trackCategory, trackAction) {
    // PDF exports are server side, so only check if we have credits (and don't debit) for those.
    var checkOnly = !asPng;
    var offerManager = new window.OfferManager();
    offerManager.requestExport(function() {
        Chart.save();
        if (asPng) {
            Chart.exportPNG();
        } else {
            Chart.exportPNGToPDF();
        }

        if (typeof(FreemiumBox) !== "undefined") {
            FreemiumBox.deductCredit();
        }
        _track(trackCategory, trackAction);


    }, "/new-account-for-doc?" + window.location.search.substr(1), checkOnly);
};



// WEBPACK FOOTER //
// ./src-assets/js/chart.js